import { AsIsTableDataTransform, ColumnConfig, ColumnConfigOptions, ColumnText, CombinedPortfoliosMultiColumnGridExtractorConfig, ConditionalExtractor, ExtractAndFormatExtractor, LabelFormatter, LodashExtractor, LodashSeriesEnricherMapper, NumberFormatter, SimplePortfolioExtractorConfig, StoreLodashExtractor, TabConfig, TablePerPortfolioMultipleSeriesExtractorConfig } from '@ddt-web/data-service';

import { FAMILY_COLUMN_CONFIG, FAMILY_HOLDING_COLUMN_CONFIG, HOLDINGS_ENRICHER, MODEL_PORTFOLIO_FILTER_FUNCTION, MODEL_PORTFOLIO_FILTER_SELECTED_IDS } from './family-column.config';

export const FAMILY_CHANGES_TO_HOLDINGS_HEADER = new TabConfig(
	'changesToHoldings.header',
	null,
	new TablePerPortfolioMultipleSeriesExtractorConfig(
		[
			new LodashSeriesEnricherMapper(
				['families'],
				['families'],
				'families.models',
				(portfolio: any, data: any) => {
					return {
						...portfolio, managementType: portfolio?.managementType || data?.families?.managementType
					};
				},
				MODEL_PORTFOLIO_FILTER_FUNCTION
			)
		],
		null,
		[
			ColumnConfig.create({
				label: new ColumnText('HOLDING_TICKER', 'Ticker'),
				id: 'ticker',
				extractor: new LodashExtractor('identifier', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('HOLDING_NAME', 'Name'),
				id: 'name',
				extractor: new ConditionalExtractor(
					model => model.managementType === 'research',
					new ExtractAndFormatExtractor('shortName', '', (description) => '*' + description),
					new LodashExtractor('shortName', '')
				),
				visible: true
			} as ColumnConfigOptions<ConditionalExtractor>),
			ColumnConfig.create({
				label: new ColumnText('', ''),
				id: 'portfolioId',
				extractor: new LodashExtractor('portfolioId', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>),
			ColumnConfig.create({
				label: new ColumnText('', ''),
				id: 'id',
				extractor: new LodashExtractor('id', ''),
				visible: false
			} as ColumnConfigOptions<LodashExtractor>)
		],
		FAMILY_COLUMN_CONFIG
	)
);

export const FAMILY_CHANGES_TO_HOLDINGS_TABLE_BODY = new TabConfig(
	'changesToHoldings',
	null,
	new CombinedPortfoliosMultiColumnGridExtractorConfig(
		new LodashSeriesEnricherMapper(['familyHoldings', 'positionDetails'], ['familyHoldings', 'positionDetails'], 'familyHoldings.components', HOLDINGS_ENRICHER),
		null,
		new ColumnConfig(null, null, new StoreLodashExtractor(['familyHoldings'], 'id'), 'name'),
		new ColumnConfig(null, null, new LodashExtractor('posInfo.ticker.stringValue', ''), 'ticker'),
		new ColumnConfig(null, null, new LodashExtractor('changesToHoldings', 0), 'changes',
			new NumberFormatter(NumberFormatter.NONE, 1, null, null, NumberFormatter.NONE, null, true, '-')),
		[
			new ColumnConfig(null, null, new LodashExtractor('posInfo.ticker.stringValue', ''), 'portfolioId'),
			new ColumnConfig(null, null, new LodashExtractor('posInfo.issueName.stringValue', ''), 'description'),
			new ColumnConfig(null, null, new LodashExtractor('posInfo.ticker.stringValue', ''), 'requestId'),
			new ColumnConfig(null, null, new LodashExtractor('formattedAcAssetClass', 'Other'), 'assetClass', new LabelFormatter('HOLDINGS_CHART'))
		],
		AsIsTableDataTransform.instance,
		Number.MAX_VALUE,
		(port => MODEL_PORTFOLIO_FILTER_SELECTED_IDS(port[0]))
	)
);

export const FAMILY_CHANGES_TO_HOLDINGS_FLAG = new TabConfig(
	'changesToHoldingsFlag',
	null,
	new SimplePortfolioExtractorConfig(
		null,
		[
			ColumnConfig.create({
				id: 'noPreviousHoldings',
				extractor: new StoreLodashExtractor(['familyHoldings'], 'noPreviousHoldings', '')
			} as ColumnConfigOptions<StoreLodashExtractor>)
		],
		FAMILY_HOLDING_COLUMN_CONFIG
	)
);
